export default "__VITE_ASSET__394947fe__"